import func from '@/script/func';
const state = {
    info: {
        __process: 1,
        __js: "/cron/index.js",
        __process_id: "",
    },
}

//修改数据，调用方式this.$store.commit('increment', 2)
const mutations = {
    //设置进程id
    setProcessId(state, processId) {
        state.info.__process_id = processId;
    },
}

//专门处理异步，调用方式：this.$store.dispatch('fetchUser')
const actions = {
    //初始化
    async init({ state, commit, rootState }) {
        // console.log("------初始化", func)
        let p = func.sget("process_list");
        if (p && p.cron) {
            commit("setProcessId", p.cron)
        } else {
            //创建线程
            let rs = await rootState.eapi.invoke("fork@create", state.info);
            if (rs.code == 1) {
                // console.log("------------rs", rs);
                let p2 = func.sget("process_list");
                if (!p2) {
                    p2 = {};
                }
                p2.cron = rs.__process_id;
                func.ssave("process_list", p2)
                // console.log("---------创建进程")
                commit("setProcessId", rs.__process_id)
            } else {
                //创建进程失败
                console.warn("------------------创建子进程失败");
                return;
            }
        }
        await rootState.eapi.invoke("cron@run", state.info);
    },
}

//state 的计算属性，像 computed，使用方式：this.$store.getters.isLogin
const getters = {

}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}